<svg version="1.1" viewBox="0 0 160 160" class="circles">
  @for (circle of circles(); track $index) {
    @let radius = 76 - 10 * $index;
    @let isActive = isActiveCircle($index);

    <circle
      class="track"
      cx="80"
      cy="80"
      stroke-width="8"
      fill="none"
      [attr.r]="radius"
      [attr.stroke-opacity]="isActive ? 1 : 0"
    />
    <circle
      class="circle"
      cx="80"
      cy="80"
      stroke-width="8"
      fill="none"
      [attr.r]="radius"
      [attr.stroke-opacity]="
        isActive ? circleOpacityActive() : circleOpacityInactive()
      "
      [attr.style]="`
        --fip-circular-progress-circle-percentage: ${circle.percentage <= 100 ? circle.percentage : 100};
        --fip-circular-progress-circle-radius: ${radius};
        --fip-circular-progress-circle-stroke: var(--tw-color-${circle.stroke}-600);
      `"
    />
  }
</svg>
<div class="label">{{ label() }}</div>
